import { Link, Flex, HStack, Icon, Text, useColorMode } from '@chakra-ui/react';
import { GrLinkedin, GrGithub } from 'react-icons/gr';
import { SiGmail } from 'react-icons/si';

export const redirectToGmail = () => {
  const email = 'darah3ng@gmail.com';
  const subject = 'Hello Dara';
  const body = "Hi Dara, I'd like to discuss...";
  return `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
};

function Footer() {
  const { colorMode } = useColorMode();
  const hoverTextColor = { color: '#ff9500', borderRadius: '5' };
  const currentYear = new Date().getFullYear();

  return (
    <Flex
      as="footer"
      direction="column"
      alignItems="center"
      justifyContent="center"
      gap={4}
      mt={10}
      mb={5}
    >
      <HStack
        direction={'row'}
        justifyContent="center"
        spacing={['none', 14, 16]}
      >
        <Link
          href={redirectToGmail()}
          isExternal
          aria-label="Email Dara"
          color={`mode.${colorMode}.career.subtext`}
          _hover={hoverTextColor}
        >
          <Icon as={SiGmail} w="6" h="6" />
        </Link>
        <Link
          href="https://github.com/darah3ng"
          isExternal
          aria-label="Dara Heng on GitHub"
          color={`mode.${colorMode}.career.subtext`}
          _hover={hoverTextColor}
        >
          <Icon as={GrGithub} w="6" h="6" />
        </Link>
        <Link
          href="https://www.linkedin.com/in/dara-heng-2b4a21133/"
          isExternal
          aria-label="Dara Heng on LinkedIn"
          color={`mode.${colorMode}.career.subtext`}
          _hover={hoverTextColor}
        >
          <Icon as={GrLinkedin} w="6" h="6" />
        </Link>
      </HStack>
      <Text
        fontSize="sm"
        textAlign="center"
        mt={5}
        color={`mode.${colorMode}.career.subtext`}
      >
        &copy; 2022 &ndash; {currentYear} Dara Heng. Designed and built with
        love.
      </Text>
    </Flex>
  );
}

export default Footer;
